import { useAuth } from "@/context/auth-context";
import { getIntercomTokenOptions } from "@/features/intercom/queries";
import { getHost } from "@/lib/utils";
import { Intercom } from "@intercom/messenger-js-sdk";
import { IntercomSettings } from "@intercom/messenger-js-sdk/dist/types";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { IntercomIcon } from "../icons";

const INTERCOM_APP_ID = "idk0n2sl";

export default function IntercomUserChat() {
	const host = getHost();
	const { user } = useAuth();

	const isKashuOrPayova = host === "kashu" || host === "payova";

	const query = useQuery(
		getIntercomTokenOptions(user?.id?.toString() || "", {
			enabled: isKashuOrPayova && user !== undefined,
		}),
	);

	useEffect(() => {
		if (!isKashuOrPayova || !query.data?.token) {
			return;
		}

		const intercomSettings: IntercomSettings = {
			app_id: INTERCOM_APP_ID,
			user_id: user.id.toString(),
			email: user.email,
			phone: user.phone_number,
			name: `${user.first_name} ${user.last_name}`,
			intercom_user_jwt: query.data.token,
			custom_launcher_selector: "#intercom-user-launcher",
			hide_default_launcher: true,
		};

		Intercom(intercomSettings);
	}, [isKashuOrPayova, user, query.data?.token]);

	if (!isKashuOrPayova) {
		return null;
	}

	return (
		<button
			id="intercom-user-launcher"
			type="button"
			aria-label="Open chat"
			className="fixed z-[9999] flex h-12 w-12 items-center justify-center rounded-full bg-primary-600 text-white shadow-lg transition-transform hover:scale-105 active:scale-95 top-4 left-4 sm:top-6 sm:left-6 md:top-8 md:left-8"
		>
			<IntercomIcon className="w-6 h-6" />
		</button>
	);
}
